import { createContext, useContext } from "react";

/**
 * Transient override for `<Window>`'s `size` prop. Used by dock drag-out to keep
 * the floating panel at the slot's dimensions; cleared on release.
 */
export const WindowSizeContext = createContext<{ width: number; height: number } | null>(null);

export function useWindowSizeOverride(): { width: number; height: number } | null {
    return useContext(WindowSizeContext);
}
